require('./command.js');

PegasusTemplate.ChangeTemplateWidthCommand = PegasusTemplate.Command.extend({
  executeWidth: null,
  unexecuteWidth: null,
  execute: function(){
    PegasusTemplate.lookupController('toolbar').set('selectedTemplateWidth', this.get('executeWidth'));
    this._super();
  },
  unexecute: function(){
    PegasusTemplate.lookupController('toolbar').set('selectedTemplateWidth', this.get('unexecuteWidth'));
    this._super();
  }
});
